export enum KnowledgeCardsIntentType {
	PERSON = 'PERSON',
	TEAM = 'TEAM',
	AGENT = 'AGENT',
}

export enum KnowledgeCardsRowType {
	PERSON = 'PERSON',
	WORK = 'WORK',
	AGENT = 'AGENT',
}
